import { useState } from 'react';

import { tracking } from '@iwoca/frontend-tracking-library';
import { fetchPostPasswordlessEmail } from '@iwoca/lapi-client/edge';
import { useMutation } from '@tanstack/react-query';
import { useFormContext } from 'react-hook-form';

import styles from './LoginLink.module.css';
import TickIcon from '../../../Seller/Integrations/assets/tick.svg';

export const LoginLink = () => {
  const { watch } = useFormContext();
  const emailAddress = watch('emailAddress');
  const [isMagicLinkSent, setIsMagicLinkSent] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const { mutateAsync, isPending } = useMutation({
    mutationFn: async ({
      email,
      redirect_to,
    }: {
      email: string;
      redirect_to?: string;
    }) => {
      setIsMagicLinkSent(false);
      setError(null);

      try {
        await fetchPostPasswordlessEmail({
          body: {
            data: {
              email,
              redirect_to,
            },
          },
        });
        setIsMagicLinkSent(true);
        tracking.ampli.loginLinkRequested();
      } catch (e) {
        //@ts-expect-error
        setError(e.message!);
      }
    },
  });

  return (
    <div className={styles.wrap}>
      <div className={styles.heading}>
        👋 You already have an iwocaPay account.
      </div>
      <div className={styles.descriptionText}>
        We will send you an email with a link which will allow you to log you in
        just by clicking a single link.{' '}
        <button
          type="button"
          onClick={async () =>
            await mutateAsync({
              email: emailAddress,
              redirect_to: window.location.pathname + window.location.search,
            })
          }
          className={styles.sendEmailLink}
        >
          Click here to send the email
        </button>
      </div>

      {isPending && <p>Sending email...</p>}
      {error && (
        <p className={styles.error}>Something went wrong. Please try again.</p>
      )}

      {isMagicLinkSent && (
        <div className={styles.successWrap}>
          <span className={styles.emailSuccess}>
            <img src={TickIcon} alt="" />
            Email sent successfully to {emailAddress}
            <span className={styles.spamMessage}>
              {' '}
              Remember to check your spam folder!
            </span>
          </span>
        </div>
      )}
    </div>
  );
};
